<template>
    <div class="col-12">
        <h4 class="bg-success p-2">
            Bloco I – Serviço Especializado para Pessoas em Situação de Rua
        </h4>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>A.</th>
                <th>
                    Pessoas em situação de rua atendidas no Serviço durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th>Sexo</th>
                <th>0 a 12 anos</th>
                <th>13 a 17 anos</th>
                <th>18 a 39 anos</th>
                <th>40 a 59 anos</th>
                <th>60 anos ou mais</th>
            </tr>
            <tr>
                <td rowspan="2">A.1.</td>
                <td rowspan="2">
                    Quantidade e perfil das pessoas em situação de rua atendidas
                    no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td rowspan="2">{{ dados.total_situacao }}</td>
                <td>Masculino</td>
                <td>{{ dados.total_situacao_0_12_m }}</td>
                <td>{{ dados.total_situacao_13_17_m }}</td>
                <td>{{ dados.total_situacao_18_39_m }}</td>
                <td>{{ dados.total_situacao_40_59_m }}</td>
                <td>{{ dados.total_situacao_60_mais_m }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.total_situacao_0_12_f }}</td>
                <td>{{ dados.total_situacao_13_17_f }}</td>
                <td>{{ dados.total_situacao_18_39_f }}</td>
                <td>{{ dados.total_situacao_40_59_f }}</td>
                <td>{{ dados.total_situacao_60_mais_f }}</td>
            </tr>
        </table>
        <p>
            <b class="text-danger">Atenção!</b> Em A1 cada pessoa deve ser
            contada uma única vez a cada
            {{ periodo == "Mensal" ? "mês" : "ano" }}, mesmo que tenha sido
            atendida várias vezes durante este mesmo
            {{ periodo == "Mensal" ? "mês" : "ano" }}.
        </p>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>B.</th>
                <th>
                    Características específicas identificadas em pessoas atendidas no Serviço durante o {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <th>B.1.</th>
                <th>Pessoas usuárias de crack ou outras drogas ilícitas</th>
                <th>{{ dados.total_usuarios_drogas }}</th>
            </tr>
            <tr>
                <th>B.2.</th>
                <th>Migrantes</th>
                <th>{{ dados.total_migrantes }}</th>
            </tr>
            <tr>
                <th>B.3.</th>
                <th>Pessoas com doença ou transtorno mental</th>
                <th>{{ dados.total_doenca_transtorno_mental }}</th>
            </tr>
        </table>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>C.</th>
                <th>
                    Cadastramento de pessoas em situação de rua durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <th>C.1.</th>
                <th>
                    Pessoas que foram
                    <span class="text-primary">incluídas</span> no Cadastro
                    Único para Programas Sociais, no
                    {{ periodo == "Mensal" ? "mês" : "ano" }}
                </th>
                <th>{{ dados.total_incluidos_cadunico }}</th>
            </tr>
            <tr>
                <th>C.2.</th>
                <th>
                    Pessoas que realizaram
                    <span class="text-primary">atualização</span> do Cadastro
                    Único para Programas Sociais, no
                    {{ periodo == "Mensal" ? "mês" : "ano" }}
                </th>
                <th>{{ dados.total_atualizacao_cadunico }}</th>
            </tr>
        </table>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>D.</th>
                <th>
                    Volume total de atendimentos realizados no
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <th>D.1.</th>
                <th>
                    Quantidade total de atendimentos realizados (compreendida
                    como a soma do número de atendimentos realizados a cada dia,
                    durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência)
                </th>
                <th>{{ verifyValue(dados.total_atendimentos) }}</th>
            </tr>
        </table>
        <h4 class="bg-success p-2">
            Bloco II - Serviço Especializado em Abordagem Social no Centro POP
        </h4>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>E.</th>
                <th>
                    Pessoas em situação de rua atendidas no Serviço durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </th>
                <th>Total</th>
                <th>Sexo</th>
                <th>0 a 12 anos</th>
                <th>13 a 17 anos</th>
                <th>18 a 59 anos</th>
                <th>60 anos ou mais</th>
            </tr>
            <tr>
                <td rowspan="2">E.1.</td>
                <td rowspan="2">
                    Quantidade de pessoas abordadas pelo Serviço de Abordagem Social, durante o {{ periodo == "Mensal" ? "mês" : "ano" }} de referência
                </td>
                <td rowspan="2">{{ dados.total_situacao_mes }}</td>
                <td>Masculino</td>
                <td>{{ dados.total_situacao_mes_0_12_m }}</td>
                <td>{{ dados.total_situacao_mes_13_17_m }}</td>
                <td>{{ dados.total_situacao_mes_18_59_m }}</td>
                <td>{{ dados.total_situacao_mes_60_mais_m }}</td>
            </tr>
            <tr>
                <td>Feminino</td>
                <td>{{ dados.total_situacao_mes_0_12_f }}</td>
                <td>{{ dados.total_situacao_mes_13_17_f }}</td>
                <td>{{ dados.total_situacao_mes_18_59_f }}</td>
                <td>{{ dados.total_situacao_mes_60_mais_f }}</td>
            </tr>
        </table>
        <p>
            <b class="text-danger">Atenção!</b> Em E1 cada pessoa deve ser
            contada uma única vez a cada
            {{ periodo == "Mensal" ? "mês" : "ano" }}, mesmo que tenha sido
            abordada várias vezes durante este mesmo
            {{ periodo == "Mensal" ? "mês" : "ano" }}.
        </p>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th colspan="2">
                    Situações identificadas pelo Serviço Especializado em
                    Abordagem Social, no
                    {{ periodo == "Mensal" ? "mês" : "ano" }}
                    de referência
                </th>
                <th>Total</th>
            </tr>
            <tr>
                <th>E.2.</th>
                <th>
                    Crianças ou adolescentes em situação de trabalho infantil
                    (até 15 anos)
                </th>
                <th>{{ dados.total_crianca_trabalho_infantil }}</th>
            </tr>
            <tr>
                <th>E.3.</th>
                <th>
                    Crianças ou adolescentes em situação de exploração sexual
                </th>
                <th>{{ dados.total_crianca_exploracao_sexual }}</th>
            </tr>
            <tr>
                <th>E.4.</th>
                <th>
                    Crianças ou adolescentes usuárias de crack ou outras drogas
                </th>
                <th>{{ dados.total_crianca_uso_drogas }}</th>
            </tr>
            <tr>
                <th>E.5.</th>
                <th>
                    Pessoas adultas usuárias de crack ou outras drogas ilícitas
                </th>
                <th>{{ dados.total_adultos_uso_drogas }}</th>
            </tr>
            <tr>
                <th>E.6.</th>
                <th>Migrantes</th>
                <th>{{ dados.total_migrante_mes }}</th>
            </tr>
        </table>
        <p>
            <b class="text-danger">Atenção!</b> Os itens E2 a E6 buscam
            identificar apenas alguns "perfis/condições" das pessoas abordadas,
            portanto é normal que algumas pessoas contadas no item E1 não se
            enquadrem em nenhum dos "perfis/condições" descritos, enquanto
            outras pessoas podem se enquadrar simultaneamente em mais de um;
            portanto, a soma de E2 a E6 não terá, necessariamente, o mesmo valor
            relatado no total de E1.
        </p>
        <table class="table table-bordered">
            <tr class="bg-success">
                <th>F.</th>
                <th>Volume de abordagens realizadas</th>
                <th>Total</th>
            </tr>
            <tr>
                <th>F.1.</th>
                <th>
                    Quantidade total de abordagens realizadas (compreendida como
                    o número de pessoas abordadas, multiplicado pelo número de
                    vezes em que foram abordadas durante o
                    {{ periodo == "Mensal" ? "mês" : "ano" }})
                </th>
                <th>{{ dados.total_abordagem }}</th>
            </tr>
        </table>
        <p>
            <b class="text-danger">Atenção!</b> Quando a abordagem é feita a um
            grupo, cada pessoa do grupo é contada como uma abordagem.
        </p>

        <h4 v-if="footer != false">
            Nome e cargo da pessoa responsável no Centro Pop pelas informações:
        </h4>
        <div class="row px-3 mt-4" v-if="footer != false">
            <div class="col-8 pl-0 border-bottom">Assinatura:</div>
            <div class="col-4 border-bottom">CPF:</div>
        </div>

        <div class="footer_impressao">
            <div v-if="tecnico">
                <span><strong>Técnico responsável:</strong> {{ tecnico.nome }}</span>
                <span v-if="tecnico.profissao"><strong>Cargo:</strong> {{ tecnico.profissao }}</span>
                <span><strong>Data/Hora da emissão:</strong> {{ dataHoraAtual }}</span>
            </div>
        </div>

    </div>
</template>

<style>

    .footer_impressao {
        display: none;
    }

    /* Se quiser que apareça apenas na impressão */
    @media print {
        .footer_impressao {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;
            flex-wrap: wrap;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            background: white;
            border-top: 1px solid #ccc;
            padding: 8px 20px;
            font-size: 14px;
        }
    }

    /* Adiciona o separador " - " automaticamente entre os spans */
    .footer_impressao span:not(:last-child)::after {
        content: " - ";
        margin: 0 5px;
    }

</style>

<script>
export default {
    name: "RMA_CENTRO_POP",
    props: ["mes", "ano", "periodo", "unidade", "dados", "header", "footer"],
    data() {
        return {
            unidadeSelected: "",
            app_cidade: this.$store.state.settings.app_cidade,
            app_data_atual: this.$store.state.settings.app_data_atual,
            meses: [
                { id: "01", value: "Janeiro" },
                { id: "02", value: "Fevereiro" },
                { id: "03", value: "Março" },
                { id: "04", value: "Abril" },
                { id: "05", value: "Maio" },
                { id: "06", value: "Junho" },
                { id: "07", value: "Julho" },
                { id: "08", value: "Agosto" },
                { id: "09", value: "Setembro" },
                { id: "10", value: "Outubro" },
                { id: "11", value: "Novembro" },
                { id: "12", value: "Dezembro" },
            ],
            tecnico: null,
            dataHoraAtual: null,
        };
    },
    watch: {
        unidade() {
            this.getUnidade();
        },
    },
    mounted() {
        this.getTecnico();
        this.definirDataHoraAtual();
    },
    methods: {

        getMes(mes) {
            const result = this.meses.filter((item) => item.id == this.mes);
            return result[0] ? result[0].value : "";
        },

        getUnidade() {
            axios
                .get(`api/dashboard/unidades/${this.unidade}`)
                .then((response) => {
                    this.unidadeSelected = response.data.data;
                });
        },

        verifyValue(value) {
            return value == 0 || value == "0" ? "" : value;
        },

        getTecnico() {
            const userId = this.$store.state.user.id;

            axios.get(`/api/dashboard/tecnico/get/user_id/${userId}`).then((response) => {
                this.tecnico = response.data.data;
            })
            .catch((error) => {
                console.error("Erro ao buscar técnico:", error);
            });
        },

        definirDataHoraAtual() {
            const agora = new Date();
            const dataFormatada = agora.toLocaleDateString("pt-BR");
            const horaFormatada = agora.toLocaleTimeString("pt-BR", {
                hour: "2-digit",
                minute: "2-digit",
            });
            this.dataHoraAtual = `${dataFormatada} ${horaFormatada}`;
        },

    },
};
</script>
<style>
.router-link-exact-active {
    cursor: pointer;
}
</style>
